import { Close, NotificationsRounded } from '@mui/icons-material';
import { Avatar, IconButton, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { deleteAllQueue, deleteQueue } from 'app/actions/notification';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const Snackbar = () => {
  const dispatch = useDispatch();
  const { session } = useSelector((state) => state.session);
  const { items } = useSelector((state) => state.notification);
  const handleNotificationClose = (value) => {
    dispatch(deleteQueue(value));
  };
  const handleAllNotificationsClose = () => {
    dispatch(deleteAllQueue(items));
  };

  const handleOpenAction = ({ action, ...value }) => {
    action();
    dispatch(deleteQueue(value));
  };
  useEffect(() => {
    if (!session.show_notification) {
      items.map((item) => {
        if (item.isTransportEvent) {
          handleNotificationClose(item);
        }
      });
    }
  }, [items]);
  return (
    <Stack
      direction='column'
      sx={(theme) => ({
        position: 'absolute',
        right: theme.spacing(3),
        bottom: theme.spacing(3),
        zIndex: theme.zIndex.notistack,
        maxHeight: '446px',
        width: '315px',
      })}>
      {items.length > 0 && session.can_close_all_notification ? (
        <Stack
          direction='row'
          alignItems='center'
          sx={(theme) => ({
            right: theme.spacing(1.5),
            top: theme.spacing(1.5),
            margin: '0 0 10px 0',
            justifyContent: 'space-between',
            width: '300px',
            flexShrink: 0,
            backgroundColor: 'background.paper',
            padding: theme.spacing(1, 1.5, 1, 2),
            borderRadius: theme.shape.borderRadius,
            opacity: '1',
            boxShadow: '0 1px 3px ' + alpha(theme.palette.grey.main, 0.12),
            transition: 'none',
            overflow: 'hidden',
            button: {
              padding: '6px',
            },
            '.MuiTypography-root': {
              whiteSpace: 'nowrap',
              margin: '0 12px',
              width: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              fontSize: '13px',
              lineHeight: '24px',
              color: theme.palette.common.black,
            },
            '.MuiAvatar-root': {
              width: '30px',
              height: '30px',
            },
          })}>
          <Avatar>
            <NotificationsRounded fontSize='small' />
          </Avatar>
          <Typography>Закрыть все оповещения</Typography>
          <IconButton color='default' onClick={handleAllNotificationsClose}>
            <Close fontSize='small' />
          </IconButton>
        </Stack>
      ) : null}
      <Stack
        direction='column'
        className='MuiNotifyStack-root'
        sx={(theme) => ({
          maxHeight: '446px',
          width: '315px',
          overflowY: 'auto',
          scrollbarWidth: 'thin',
          scrollbarColor: `${theme.palette.grey[500]} ${alpha(theme.palette.grey[500], 0.1)}`,
          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: theme.palette.grey[500],
            borderRadius: '3px',
            opacity: 0,
            transition: 'opacity 0.3s ease',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: alpha(theme.palette.grey[500], 0.1),
            opacity: 0,
            transition: 'opacity 0.3s ease',
          },
          '&:hover::-webkit-scrollbar-thumb': {
            opacity: 1,
          },
          '&:hover::-webkit-scrollbar-track': {
            opacity: 1,
          },
          '.MuiNotifyStack-item': {
            bgcolor: 'background.paper',
            marginBottom: theme.spacing(1),
            '&:last-of-type': {
              marginBottom: theme.spacing(0),
            },
          },
        })}>
        {items.map((item) => {
          if (!session.show_notification && item.isTransportEvent) {
            return null;
          }
          return (
            <Stack
              key={item.id}
              direction='column'
              className='MuiNotifyStack-item'
              sx={(theme) => ({
                width: '300px',
                flexShrink: 0,
                bgcolor: 'background.paper',
                padding: theme.spacing(0),
                borderRadius: theme.shape.borderRadius,
                opacity: '1',
                boxShadow: '0 1px 3px ' + alpha(theme.palette.grey.main, 0.12),
                transition: 'none',
                overflow: 'hidden',
              })}>
              <Stack
                direction='row'
                alignItems='center'
                sx={(theme) => ({
                  bgcolor: item.color ? theme.palette[item.color].main : 'background.default',
                  minHeight: '48px',
                  position: 'relative',
                })}>
                <Stack
                  direction='row'
                  alignItems='center'
                  sx={(theme) => ({
                    padding: theme.spacing(0, 2),
                    '.MuiTypography-root': {
                      whiteSpace: 'nowrap',
                      margin: '0 12px',
                      width: '100%',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      fontSize: '13px',
                      lineHeight: '24px',
                    },
                    '.MuiAvatar-root': {
                      width: '30px',
                      height: '30px',
                      bgcolor: item.color ? theme.palette[item.color].dark : alpha(theme.palette.primary.main, 0.12),
                      path: {
                        fill: item.color ? theme.palette.background.default : theme.palette.primary.main,
                      },
                    },
                  })}>
                  <Avatar>
                    <NotificationsRounded fontSize='small' />
                  </Avatar>
                  <Typography variant='body1'>{item.isTransportEvent ? 'Одновременный слив' : 'Новое уведомление'}</Typography>
                </Stack>
                <Stack
                  direction='row'
                  alignItems='center'
                  component='ul'
                  sx={(theme) => ({
                    position: 'absolute',
                    right: theme.spacing(1.5),
                    top: theme.spacing(1.5),
                    margin: '0',
                    marginLeft: 'auto',
                    listStyle: 'none',
                    li: {
                      margin: '0',
                      padding: '0',
                      display: 'flex',
                      alignItems: 'center',
                      button: {
                        width: '32px',
                        height: '32px',
                      },
                    },
                    'li:not(:last-of-type) path': {
                      fill: theme.palette.text.secondary,
                    },
                  })}>
                  <li>
                    <IconButton color='default' onClick={() => handleNotificationClose(item)}>
                      <Close fontSize='small' />
                    </IconButton>
                  </li>
                </Stack>
              </Stack>
              <Stack
                direction='row'
                sx={(theme) => ({
                  display: 'grid',
                  gap: 0,
                  padding: theme.spacing(2),
                  '.MuiTypography-root:nth-of-type(2)': {
                    textAlign: 'right',
                    cursor: 'pointer',
                    color: theme.palette.primary.main,
                  },
                })}>
                <Typography variant='body1'>{item.text}</Typography>
                {item.action && (
                  <Typography variant='body1' onClick={() => handleOpenAction(item)}>
                    Посмотреть подробнее
                  </Typography>
                )}
              </Stack>
            </Stack>
          );
        })}
      </Stack>
    </Stack>
  );
};

export default Snackbar;
